// extracted by mini-css-extract-plugin
export var error = "styles-module--error--e1560";
export var loading = "styles-module--loading--ec7ae";
export var mobile = "styles-module--mobile--3bb6b";